const createViewMap = (views) => {
    const viewMap = new Map();
    let idx = views.length;
    while (idx--) {
        const v = views[idx];
        if (v !== null) {
            viewMap.set(v.id, v);
        }
    }
    return viewMap;
};
/**
 * View model factory for the entire graph
 */
class GraphViewFactory {
}
GraphViewFactory.createGraphView = (nodeViews, edgeViews) => {
    const nvMap = createViewMap(nodeViews);
    const evMap = createViewMap(edgeViews);
    const gv = {
        nodeViews: nvMap,
        edgeViews: evMap
    };
    return gv;
};
export default GraphViewFactory;
